<template>
  <div class="carousel-3d-container">
    <h2 class="carousel-title">工作环境</h2>
    <swiper :options="swiperOption" ref="mySwiper" >
      <swiper-slide v-for="item in carouselItems" :key="item.id" :data-swiper-slide-index="item.id">
        <div class="slide-content">
          <img :src="item.imageSrc" :alt="item.alt" class="slide-image" />
          <div class="slide-title">
            <h3>{{ item.title }}</h3>
          </div>
        </div>
      </swiper-slide>

      <!-- 分页 -->
      <div class="swiper-pagination" slot="pagination"></div>

    </swiper>
  </div>
</template>

<script>
export default {
  name: 'Carousel3D',
  props: {
    carouselItems: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      swiperOption: {
        loop: true,
        speed: 600,
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
          pauseOnMouseEnter: true
        },
        grabCursor: true,
        centeredSlides: true,
        slidesPerView: 3,
        initialSlide: 0,
        spaceBetween: -260,
        effect: 'coverflow',
        coverflowEffect: {
          rotate: 0,
          stretch: 0,
          depth: 100,
          modifier: 2.5,
          slideShadows: true
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        breakpoints: {
          320: {
            slidesPerView: 1,
            spaceBetween: 10
          },
          768: {
            slidesPerView: 3,
            spaceBetween: -200
          },
          1024: {
            slidesPerView: 3,
            spaceBetween: -260
          }
        }
      }
    }
  },
  mounted() {
    // 确保 Swiper 实例已创建
    this.$nextTick(() => {
      const swiper = this.$refs.mySwiper.$swiper

      // 打印完整的 Swiper 配置
      console.log('完整的 Swiper 配置:', {
        ...this.swiperOption,
        navigation: {
          ...this.swiperOption.navigation,
          enabled: true  // 确保导航按钮已启用
        }
      })

      // 检查 Swiper 实例和导航按钮
      console.log('Swiper 实例状态:', {
        isInitialized: !!swiper,
        totalSlides: swiper?.slides?.length,
        activeIndex: swiper?.activeIndex,
        isLoop: swiper?.params?.loop,
        navigation: swiper?.navigation
      })

      // 检查导航按钮元素是否存在
      const prevBtn = document.querySelector('.swiper-button-prev')
      const nextBtn = document.querySelector('.swiper-button-next')
      console.log('导航按钮状态:', {
        prevButton: {
          exists: !!prevBtn,
          isVisible: prevBtn ? window.getComputedStyle(prevBtn).display !== 'none' : false
        },
        nextButton: {
          exists: !!nextBtn,
          isVisible: nextBtn ? window.getComputedStyle(nextBtn).display !== 'none' : false
        }
      })

      if (swiper) {
        // 添加导航事件监听
        swiper.on('navigationNext', () => {
          console.log('下一张按钮被点击')
        })

        swiper.on('navigationPrev', () => {
          console.log('上一张按钮被点击')
        })

        swiper.on('slideChange', () => {
          console.log('幻灯片切换:', {
            当前索引: swiper.activeIndex,
            实际索引: swiper.realIndex,
            总数: swiper.slides.length
          })
        })

        // 手动测试导航方法
        console.log('Swiper 导航方法:', {
          slidePrev: typeof swiper.slidePrev === 'function',
          slideNext: typeof swiper.slideNext === 'function'
        })
      } else {
        console.error('Swiper 实例未能正确初始化')
      }

      // 检查传入的数据
      console.log('轮播图数据状态:', {
        数据长度: this.carouselItems.length,
        数据示例: this.carouselItems[0],
        是否为数组: Array.isArray(this.carouselItems)
      })
    })
  }
}
</script>

<style scoped>
.carousel-3d-container {
  width: 100%;
  max-width: 1400px;
  margin: 0 auto;
  padding: 60px 0;
  position: relative;
  overflow: visible;
  background-color: rgb(255, 255, 255);
}

.carousel-title {
  text-align: center;
  font-size: 32px;
  font-weight: 600;
  color: #333;
  margin-bottom: 40px;
  position: relative;
}

.carousel-title::after {
  content: '';
  position: absolute;
  bottom: -10px;
  left: 50%;
  transform: translateX(-50%);
  width: 60px;
  height: 3px;
  background-color: #1890ff;
  border-radius: 2px;
}

.swiper-slide {
  background: transparent;
  border-radius: 8px;
  overflow: hidden;  /* 改回 hidden 防止内容溢出 */
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  opacity: 0.4;
  transform: scale(0.6);
  height: auto;
  transform-origin: center center;
  will-change: transform;
}

.swiper-slide-active {
  opacity: 1;
  transform: scale(1.2);
  z-index: 2;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.2);
  image-rendering: -webkit-optimize-contrast;  /* 优化图片渲染 */
  image-rendering: crisp-edges;
}

.swiper-slide-prev,
.swiper-slide-next {
  opacity: 0.7;
  transform: scale(0.8);
  z-index: 1;
}

.slide-content {
  width: 130%;
  height: 100%;  /* 改为100%确保填充整个容器 */
  position: relative;
  overflow: hidden;  /* 改回 hidden 防止内容溢出 */
  margin-left: -15%;
  aspect-ratio: 16/9;
  transform-origin: center center;
  will-change: transform;
  display: flex;  /* 使用flex布局确保内容完全填充 */
  align-items: center;
  justify-content: center;
}

.slide-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s ease;
  backface-visibility: hidden;
  -webkit-backface-visibility: hidden;
  -webkit-transform: translateZ(0);
  transform: translateZ(0);
  display: block;  /* 防止图片底部有间隙 */
}

.slide-title {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  padding: 10px 20px;
  text-align: center;
  min-width: 200px;
  opacity: 0;
  transition: opacity 0.3s ease;
  z-index: 3;
}

.swiper-slide-active .slide-title {
  opacity: 1;
}

.slide-title h3 {
  color: #fff;
  margin: 0;
  font-size: 30px;
  font-weight: bold;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: center;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
  letter-spacing: 4px;  /* 增加字间距 */
  word-spacing: 8px;    /* 增加词间距 */
  padding: 0 10px;      /* 两侧添加内边距 */
}

/* 导航按钮样式 */
.swiper-button-prev,
.swiper-button-next {
  background-color: rgba(255, 255, 255, 0.9);
  width: 44px;
  height: 44px;
  border-radius: 50%;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
}

/* 调整导航按钮位置以适应更大的图片 */
.swiper-button-prev {
  left: 5%;
}

.swiper-button-next {
  right: 5%;
}

.swiper-button-prev:after,
.swiper-button-next:after {
  font-size: 20px;
  color: #333;
}

/* 分页器样式 */
.swiper-pagination {
  bottom: 10px !important;
}

.swiper-pagination-bullet {
  width: 8px;
  height: 8px;
  background: #fff;
  opacity: 0.6;
  margin: 0 5px;
}

.swiper-pagination-bullet-active {
  opacity: 1;
  background: #1890ff;
  transform: scale(1.4);
}
</style>
